<template>
  <div class="card card-profile">
    <img
      src="../../assets/img/bg-profile.jpg"
      alt="Image placeholder"
      class="card-img-top"
    />
    <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0 d-flex align-items-center justify-content-center">
          <el-upload
            :before-upload="uploadImg"
            action="#"
          >
            <img v-if="user && user.avatar" :src="user.avatar"
                 class="rounded-circle img-fluid border border-2 border-white"
                 alt=""
            />
          </el-upload>


        </div>
      </div>
    </div>
    <div class="card-header text-center border-0 pt-0 pt-lg-2 pb-4 pb-lg-3">
      <div class="d-flex justify-content-center">
        <el-upload
            :before-upload="uploadImg"
            action="#"
        >
          <a
            href="javascript:;"
            class="btn btn-sm btn-info mb-0 d-none d-lg-block"
            >
            {{$t('profile.editAvatar')}}
          </a>
        </el-upload>
        <a
          href="javascript:;"
          class="btn btn-sm btn-info mb-0 d-block d-lg-none"
        >
          <i class="ni ni-collection"></i>
        </a>
<!--        <a-->
<!--          href="javascript:;"-->
<!--          class="btn btn-sm btn-dark float-right mb-0 d-none d-lg-block"-->
<!--          >微信绑定</a-->
<!--        >-->
        <a
          href="javascript:;"
          class="btn btn-sm btn-dark float-right mb-0 d-block d-lg-none"
        >
          <i class="ni ni-email-83"></i>
        </a>
      </div>
    </div>
    <div class="card-body pt-0">
      <el-descriptions title="" :column="1" v-if="user">
        <el-descriptions-item :label="$t('profile.username')">
          {{user.nickname || '--'}}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('profile.callPhoneNumber')">{{user.mobile || '--'}}</el-descriptions-item>
        <el-descriptions-item :label="$t('profile.userMailbox')">{{user.email || '--'}}</el-descriptions-item>
        <el-descriptions-item :label="$t('profile.loginTime')">{{parseTime(user.loginDate) || '--'}}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script setup>
import {parseTime} from "@/utils/ruoyi"
import {userInfo, uploadUserImg} from "@/api/user";
import {onMounted, ref} from "vue";



const user = ref(null)
// 用户信息
const getUserInfo = ()=>{
  userInfo().then(res=>{
    user.value = res.data
  })
}

// 暴露方法给父组件
defineExpose({ getUserInfo });

const uploadImg = (file)=>{
  console.log(' = file', file)
  uploadUserImg(file).then(res=>{
    console.log(' = success', res)
    getUserInfo()
  }).catch(err=>{
    console.log(' = upload fail',err)
  })
}

onMounted(() => {
  // store.state.isAbsolute = true;
  // setNavPills();
  // setTooltip();
  getUserInfo()
});
</script>
